import { TemplateCardSkeleton } from '@heidi/templates';
import type { TemplateBasicInfo } from '@heidi/templates/contracts';
import TemplateCard from './templateCard';

interface TemplateCardsProps {
  templates: TemplateBasicInfo[] | undefined;
  isLoading: boolean;
}

const TemplateCards = ({ templates, isLoading }: TemplateCardsProps) => {
  const skeletons = new Array(9).fill(0);

  return (
    <div className="flex w-full flex-col items-center gap-4">
      <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {!isLoading &&
          templates?.map((template) => (
            <TemplateCard key={template.template_id} template={template} />
          ))}
        {isLoading && skeletons.map((_, i) => <TemplateCardSkeleton key={i} />)}
      </div>
    </div>
  );
};

export default TemplateCards;
